import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  const commonProps = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  };

  return {
    root: {
      display: 'grid',
      gridTemplateAreas: `
        "label"
        "value"
      `,
      gridTemplateRows: 'auto 1fr',
      gridTemplateColumns: '1fr',
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      textAlign: 'center',
      padding: theme.spacing(1),
      gap: theme.spacing(1),
      borderRadius: theme.spacing(1),
    },
    label: {
      gridArea: 'label',
      ...commonProps,
    },
    value: {
      gridArea: 'value',
      fontSize: '1.5em',
      ...commonProps,
    },
  };
};
